import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { IconCheck } from "@tabler/icons-react";
import { useComplianceInfo } from "hooks/useComplianceInfo";
import { globalStore } from "store/GlobalStore";

export default observer(function CalculationUptodateIndicator() {
  const { t } = useTranslation();
  const { getCurrentCertification, getCurrentConformity } = useComplianceInfo();

  const getCurrentCertName = () => {
    const certName =
      globalStore.currentLanguage === "en"
        ? getCurrentCertification()?.name_en
        : getCurrentCertification()?.name_de;

    const conformity = getCurrentConformity();
    if (certName === "Keine" && conformity === "Sonstige")
      return t("building.otherCertificate");
    if (certName === "Keine") return `DIN EN 15978 (${getCurrentConformity()})`;
    return certName ?? "";
  };

  return (
    <div className="flex items-center text-sm text-gray-600">
      <div className="bg-green-100 rounded-full mr-2 p-1 text-green-600">
        <IconCheck size={15} stroke={3} />
      </div>
      <span
        dangerouslySetInnerHTML={{
          __html: t("dashboard.calculatedAccordingTo", {
            certificate: getCurrentCertName(),
          }),
        }}
      ></span>
    </div>
  );
});
